.SummaryBlock {
  display: flex;
  flex-flow: row wrap;

  & > div {
    line-height: 1;
    margin-bottom: 10px;
    margin-right: 30px;
    color: var(--bs-body-color);

    &:global(.highlight) {
      color: var(--bs-primary);
    }

    & > div:global(.main) {
      font-size: 56px;
    }

    & > div:global(.sub) {
      font-size: 12px;
    }
  }
}
